import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthTokenService } from '../services/auth-token.service';

/**
 * Protège les routes nécessitant un utilisateur connecté (ex : `home/cerfa`). En cas d'absence de
 * session (cookie applicatif `given_name` non présent), redirige vers l'accueil.
 */
@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private readonly authTokenService: AuthTokenService,
    private readonly router: Router
  ) { }

  canActivate(): boolean {
    if (this.authTokenService.isConnected()) {
      return true;
    }

    this.router.navigate(['/home']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/auth.guard.ts